import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckEnclosed = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			id: "20/check-enclosed-20",
			clipPath: "url(#clip0_5924_140384)",
			children: /* @__PURE__ */ _jsxs("g", {
				id: "Union",
				children: [/* @__PURE__ */ _jsx("path", {
					d: "M3.70944 7.44994L6.20092 9.97309L10.445 5.75279L9.45802 4.76019L6.21072 7.98999L4.70624 6.46644L3.70944 7.44994Z",
					fill: "black",
					fillOpacity: .87
				}), /* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M0.703125 7.0002C0.703125 10.4736 3.52903 13.3002 7.00312 13.3002C10.4772 13.3002 13.3031 10.4736 13.3031 7.0002C13.3031 3.5268 10.4772 0.700195 7.00312 0.700195C3.52903 0.700195 0.703125 3.5268 0.703125 7.0002ZM2.10312 7.0002C2.10312 4.2982 4.30182 2.1002 7.00312 2.1002C9.70442 2.1002 11.9031 4.2982 11.9031 7.0002C11.9031 9.7022 9.70442 11.9002 7.00312 11.9002C4.30182 11.9002 2.10312 9.7022 2.10312 7.0002Z",
					fill: "black",
					fillOpacity: .87
				})]
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_5924_140384",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 14,
				height: 14,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgCheckEnclosed);
export { ForwardRef as ReactComponent };
